import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './arthauptgrp.list-view.html',
    styleUrls: ['./arthauptgrp.list-view.scss']
})
export class ArthauptgrpListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
